import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UserName } from "Components/General/UserName";
import { dayjs } from "Config/dayjs";

interface QACommentItemProps {
  data: API_Comment;
}

export const QACommentItem: React.FunctionComponent<QACommentItemProps> = ({
  data: { comment, dateCreated, ownerId },
}) => {
  return (
    <div className="dialog-comment">
      <div className="dialog-comment--text" dangerouslySetInnerHTML={{ __html: comment }} />
      <div className="dialog-comment--data">
        <span className="dialog-username">
          <FontAwesomeIcon icon={["fas", "user"]} fixedWidth={true} style={{ marginRight: 10 }} />
          <UserName id={ownerId} />
        </span>
        <span className="dialog-time">{dayjs(+dateCreated).format("lll")}</span>
      </div>
    </div>
  );
};
